import Slider from "react-slick";
import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";
import { slickDotPaging } from "../utils/slickAccessibleDots";

const CLIENT_LOGOS = [
  { href: "https://www.acap.edu.au/", src: "img/logo-acap.png", alt: "ACAP logo" },
  { href: "https://thedateroom.com/", src: "img/logo-date_room.png", alt: "Date Room logo" },
  { href: "https://web.kailashchandra.com/cashewprotect/", src: "img/logo-cashew.png", alt: "Cashew logo" },
  { href: "https://www.dept.store/", src: "img/logo-deptstore.png", alt: "Dept Store logo" },
  { href: "https://pyurvana.com/", src: "img/logo-pyurvana.png", alt: "Pyurvana logo" },
  {
    href: "https://surveys.authenticopinion.com/clientpanel",
    src: "img/logo-trueopinion.png",
    alt: "True Opinion logo",
  },
  { href: "https://thewindowdepot.com/", src: "img/logo-window_depot.png", alt: "Window Depot logo" },
  { href: "https://sae.edu.au/", src: "img/logo-sae.png", alt: "SAE logo" },
  { href: "https://web.kailashchandra.com/tosall_client/", src: "img/tosall-logo-plux.png", alt: "Tosall logo" },
  { href: "https://tipsterchallenge.com/", src: "img/logo-tipster.jpg", alt: "Tipster Challenge logo" },
  { href: "https://www.wecharge.co.in/", src: "img/logo-wechage.png", alt: "WeCharge logo" },
  { href: "https://www.wla.edu.au/", src: "img/logo-wla.png", alt: "WLA logo" },
  {
    href: "https://web.kailashchandra.com/pscs/front",
    src: "img/logo-pscs.png",
    alt: "PSCS logo",
    className: "hover u-bg-navy",
  },
];

export default function Valuableclients() {
  const reduceMotion = usePrefersReducedMotion();
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 2000,
    slidesToShow: 5,
    autoplay: !reduceMotion,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    customPaging: slickDotPaging("Go to client logo"),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          customPaging: slickDotPaging("Go to client logo"),
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="valuable">
      <Slider {...settings}>
        {CLIENT_LOGOS.map((client) => (
          <div key={client.href}>
            <div className="swiper-slide client-item">
              <a href={client.href} target="_blank" className="client-image" rel="noreferrer">
                <img
                  src={client.src}
                  alt={client.alt}
                  className={client.className || "hover"}
                />
              </a>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
